import { useCallback } from 'react';

import { useRecoilValue } from 'recoil';
import { userTokenState } from 'recoils/user/userState';

import usePageNavigate from 'hooks/common/usePageNavigate';
import useHeader from 'hooks/menu/useHeader';

/**
 * @desc 로그인 여부에 따라 지정된 경로로 이동하거나 로그인 오버레이를 띄우는 훅
 * @returns {{ authNavigate: (path: string) => void }}
 */
const useAuthNavigate = () => {
  const userToken = useRecoilValue(userTokenState);
  const { onNavClick } = usePageNavigate();
  const { onLoginBtnClick } = useHeader();

  const authNavigate = useCallback(
    (path) => {
      if (!userToken) {
        onLoginBtnClick();
      } else {
        onNavClick(path);
      }
    },
    [userToken, onNavClick, onLoginBtnClick]
  );

  return { authNavigate };
};

export default useAuthNavigate;
